import React from 'react'
import { Routes, Route } from "react-router-dom";
import Bill from "../Pages/Bill";
import Home from "../Pages/Home";

const MainNavigator = () => {
    return (
        <div>
            <Routes>
                <Route path="*" element={<Home />}></Route>
                <Route path="/" element={<Home />}></Route>
                <Route path="/:invoiceKey" element={<Bill />}></Route>
            </Routes>
        </div>
    )
}

export default MainNavigator




